import { useState } from "react"
import { useFormContext, FieldValues, Path } from "react-hook-form"
import { FiEye, FiEyeOff } from "react-icons/fi"

type Props<T extends FieldValues> = {
   label: string
   name: Path<T>
   placeholder?: string
}

export function PasswordInput<T extends FieldValues>({ label, name, placeholder }: Props<T>) {
   const [showPassword, setShowPassword] = useState(false)

   const {
      register,
      formState: { errors },
   } = useFormContext<T>()

   return (
      <div className="flex w-full flex-col gap-1.5">
         <label className="text-custom-sm-bold text-[#333333]">{label}</label>

         <div className="relative">
            <input
               {...register(name)}
               type={showPassword ? "text" : "password"}
               placeholder={placeholder}
               className="w-full rounded-md border border-gray-300 p-3 pr-10 text-sm focus:border-orange-500 focus:outline-none focus:ring-1 focus:ring-orange-500"
            />

            <button
               type="button"
               onClick={() => setShowPassword((prev) => !prev)}
               className="absolute inset-y-0 right-2 flex items-center text-gray-500"
               tabIndex={-1}
            >
               {showPassword ? <FiEye /> : <FiEyeOff />}
            </button>
         </div>

         {errors[name] && <span className="text-xs text-red-500">{errors[name]?.message as string}</span>}
      </div>
   )
}
